<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:TextAreaInput
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<textarea
		v-bind="$attrs"
		:value="modelValue"
		:class="[{'contents__error--item': errorFlg}, imeModeFlg ? 'ime-active' : 'ime-inactive']"
		:disabled="disabledFlg"
		ref="textAreaInput"
		:maxlength="maxLength"
		:tabindex="tabindex"
		@input="$emit('update:modelValue', $event.target.value)"
		@keydown.delete.stop="keyControl"
	/>
</template>

<script>
import { co_checkLength, co_isEmpty } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_trim } from '@/common/stringUtility.js';

import { STORE_ERROR_SET_INPUT_ERR, STORE_ERROR_IS_ERRFLG, STORE_ERROR_IS_INPUT_ERRFLG, STORE_VIEW_IS_MOBILE } from '@/const/store.js';

export default {
	inheritAttrs: false,
	props: {
		modelValue: { type: String, default: '' },
		name: { type: String, default: '' },
		requireFlg: { type: Boolean, default: false },
		maxLength: { type: Number, default: 0 },
		disabledFlg: { type: Boolean, default: false },
		imeModeFlg: { type: Boolean, default: true },
		tabindex: {type: String, default: '0'},			// タブインデックス
		groupId: {type: String, default: ''},			// 項目グループID
	},
	emits: ['update:modelValue'],
	data: function () {
		return {
			errorFlg: false
		}
	},
	computed: {
		errFlg: function () {
			return this.$store.getters[STORE_ERROR_IS_ERRFLG];
		}
	},
	watch: {
		disabledFlg: function(newValue) {
			if(newValue === true) {
				this.clearError();
			}
		},
		errFlg: function(newValue) {
			if(newValue === false) {
				this.clearError();
			}
		}
	},
	methods: {
		keyControl: function () {
			// キーイベントを無効化するためのメソッドのため、処理なし
		},
		// 妥当性チェック
		validate: function () {
			// TRIM処理
			let value = co_trim(this.modelValue);
			this.$emit('update:modelValue', value)

			let error = false;
			let inputError = this.$store.getters[STORE_ERROR_IS_INPUT_ERRFLG];

			// 必須チェック
			if ( this.requireFlg === true ) {
				if ( co_isEmpty(value) ) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
										{id: this.groupId, msg: co_getMessage('E0053', this.name)});
					error = true;
				}
			}

			if ( !co_isEmpty(value) ) {
				// 最大入力文字チェック
				if ( !co_checkLength(value, this.maxLength) ) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
										{id: this.groupId, msg: co_getMessage('E0055', this.name, String(this.maxLength))});
					error = true;
				}
			}

			if (!inputError && error) {
				// エラーの先頭項目の場合、フォーカス設定
				this.focus();
			}

			this.errorFlg = error;
			return !this.errorFlg;
		},
		// エラー設定
		setError: function() {
			this.errorFlg = true;
		},
		// エラークリア
		clearError: function() {
			this.errorFlg = false;
		},
		// フォーカス設定
		focus: function() {
			let inputError = this.$store.getters[STORE_ERROR_IS_INPUT_ERRFLG];
			let mobileFlg = this.$store.getters[STORE_VIEW_IS_MOBILE];
			if (inputError || !mobileFlg) {
				this.$refs.textAreaInput.focus();
			}
		}
	}
}
</script>

<style scoped>
</style>